(ns scittle.emmy
  {:no-doc true}
  (:require [scittle.core :as scittle]
            [sci.core :as sci]
    [emmy.autodiff]
    [emmy.value]
    [emmy.numbers]
    [emmy.special.factorial]
    [emmy.special.elliptic]
    [emmy.expression]
    [emmy.simplify]
    [emmy.ratio]
    [emmy.util.permute]
    [emmy.util.stopwatch]
    [emmy.util.logic]
    [emmy.util.stream]
    [emmy.util.def]
    [emmy.util.aggregate]
    [emmy.modint]
    [emmy.complex]
    [emmy.polynomial.richardson]
    [emmy.polynomial.interpolate]
    [emmy.polynomial.gcd]
    [emmy.polynomial.factor]
    [emmy.collection]
    [emmy.rational-function.interpolate]
    [emmy.euclid]
    [emmy.function]
    [emmy.matrix]
    [emmy.rational-function]
    [emmy.operator]
    [emmy.abstract.function]
    [emmy.abstract.number]
    [emmy.quaternion]
    [emmy.sci]
    [emmy.generic]
    [emmy.expression.compile]
    [emmy.expression.cse]
    [emmy.expression.analyze]
    [emmy.expression.render]
    [emmy.polynomial]
    [emmy.structure]
    [emmy.tape]
    [emmy.util]
    [emmy.pattern.consequence]
    [emmy.pattern.syntax]
    [emmy.pattern.rule]
    [emmy.pattern.match]
    [emmy.dual]
    [emmy.numsymb]
    [emmy.series]
    [emmy.mechanics.rigid]
    [emmy.mechanics.rotation]
    [emmy.mechanics.noether]
    [emmy.mechanics.routhian]
    [emmy.mechanics.lagrange]
    [emmy.mechanics.hamilton]
    [emmy.mechanics.time-evolution]
    [emmy.numerical.quadrature.boole]
    [emmy.numerical.quadrature.milne]
    [emmy.numerical.quadrature.adaptive]
    [emmy.numerical.quadrature.simpson38]
    [emmy.numerical.quadrature.simpson]
    [emmy.numerical.quadrature.infinite]
    [emmy.numerical.quadrature.common]
    [emmy.numerical.quadrature.romberg]
    [emmy.numerical.quadrature.riemann]
    [emmy.numerical.quadrature.trapezoid]
    [emmy.numerical.quadrature.bulirsch-stoer]
    [emmy.numerical.quadrature.substitute]
    [emmy.numerical.quadrature.midpoint]
    [emmy.numerical.unimin.bracket]
    [emmy.numerical.unimin.brent]
    [emmy.numerical.unimin.golden]
    [emmy.numerical.ode]
    [emmy.numerical.quadrature]
    [emmy.numerical.derivative]
    [emmy.numerical.multimin.nelder-mead]
    [emmy.numerical.minimize]
    [emmy.numerical.roots.bisect]
    [emmy.bigfraction]
    [emmy.calculus.basis]
    [emmy.calculus.frame]
    [emmy.calculus.manifold]
    [emmy.calculus.hodge-star]
    [emmy.calculus.metric]
    [emmy.calculus.covariant]
    [emmy.calculus.form-field]
    [emmy.calculus.vector-calculus]
    [emmy.calculus.connection]
    [emmy.calculus.derivative]
    [emmy.calculus.curvature]
    [emmy.calculus.vector-field]
    [emmy.calculus.coordinate]
    [emmy.calculus.map]
    [emmy.calculus.indexed]
    [emmy.env]
    [emmy.simplify.rules]
    [emmy.sr.boost]
    [emmy.sr.frames]
    [emmy.algebra.fold]
    [emmy.complex.impl]))

;; Plugin: emmy
;; Generated by build.clj

(defn init []
  (scittle/register-plugin!
   ::emmy
   {:namespaces
   {'emmy.autodiff (sci/copy-ns emmy.autodiff (sci/create-ns 'emmy.autodiff nil))
    'emmy.value (sci/copy-ns emmy.value (sci/create-ns 'emmy.value nil))
    'emmy.numbers (sci/copy-ns emmy.numbers (sci/create-ns 'emmy.numbers nil))
    'emmy.special.factorial (sci/copy-ns emmy.special.factorial (sci/create-ns 'emmy.special.factorial nil))
    'emmy.special.elliptic (sci/copy-ns emmy.special.elliptic (sci/create-ns 'emmy.special.elliptic nil))
    'emmy.expression (sci/copy-ns emmy.expression (sci/create-ns 'emmy.expression nil))
    'emmy.simplify (sci/copy-ns emmy.simplify (sci/create-ns 'emmy.simplify nil))
    'emmy.ratio (sci/copy-ns emmy.ratio (sci/create-ns 'emmy.ratio nil))
    'emmy.util.permute (sci/copy-ns emmy.util.permute (sci/create-ns 'emmy.util.permute nil))
    'emmy.util.stopwatch (sci/copy-ns emmy.util.stopwatch (sci/create-ns 'emmy.util.stopwatch nil))
    'emmy.util.logic (sci/copy-ns emmy.util.logic (sci/create-ns 'emmy.util.logic nil))
    'emmy.util.stream (sci/copy-ns emmy.util.stream (sci/create-ns 'emmy.util.stream nil))
    'emmy.util.def (sci/copy-ns emmy.util.def (sci/create-ns 'emmy.util.def nil))
    'emmy.util.aggregate (sci/copy-ns emmy.util.aggregate (sci/create-ns 'emmy.util.aggregate nil))
    'emmy.modint (sci/copy-ns emmy.modint (sci/create-ns 'emmy.modint nil))
    'emmy.complex (sci/copy-ns emmy.complex (sci/create-ns 'emmy.complex nil))
    'emmy.polynomial.richardson (sci/copy-ns emmy.polynomial.richardson (sci/create-ns 'emmy.polynomial.richardson nil))
    'emmy.polynomial.interpolate (sci/copy-ns emmy.polynomial.interpolate (sci/create-ns 'emmy.polynomial.interpolate nil))
    'emmy.polynomial.gcd (sci/copy-ns emmy.polynomial.gcd (sci/create-ns 'emmy.polynomial.gcd nil))
    'emmy.polynomial.factor (sci/copy-ns emmy.polynomial.factor (sci/create-ns 'emmy.polynomial.factor nil))
    'emmy.collection (sci/copy-ns emmy.collection (sci/create-ns 'emmy.collection nil))
    'emmy.rational-function.interpolate (sci/copy-ns emmy.rational-function.interpolate (sci/create-ns 'emmy.rational-function.interpolate nil))
    'emmy.euclid (sci/copy-ns emmy.euclid (sci/create-ns 'emmy.euclid nil))
    'emmy.function (sci/copy-ns emmy.function (sci/create-ns 'emmy.function nil))
    'emmy.matrix (sci/copy-ns emmy.matrix (sci/create-ns 'emmy.matrix nil))
    'emmy.rational-function (sci/copy-ns emmy.rational-function (sci/create-ns 'emmy.rational-function nil))
    'emmy.operator (sci/copy-ns emmy.operator (sci/create-ns 'emmy.operator nil))
    'emmy.abstract.function (sci/copy-ns emmy.abstract.function (sci/create-ns 'emmy.abstract.function nil))
    'emmy.abstract.number (sci/copy-ns emmy.abstract.number (sci/create-ns 'emmy.abstract.number nil))
    'emmy.quaternion (sci/copy-ns emmy.quaternion (sci/create-ns 'emmy.quaternion nil))
    'emmy.sci (sci/copy-ns emmy.sci (sci/create-ns 'emmy.sci nil))
    'emmy.generic (sci/copy-ns emmy.generic (sci/create-ns 'emmy.generic nil))
    'emmy.expression.compile (sci/copy-ns emmy.expression.compile (sci/create-ns 'emmy.expression.compile nil))
    'emmy.expression.cse (sci/copy-ns emmy.expression.cse (sci/create-ns 'emmy.expression.cse nil))
    'emmy.expression.analyze (sci/copy-ns emmy.expression.analyze (sci/create-ns 'emmy.expression.analyze nil))
    'emmy.expression.render (sci/copy-ns emmy.expression.render (sci/create-ns 'emmy.expression.render nil))
    'emmy.polynomial (sci/copy-ns emmy.polynomial (sci/create-ns 'emmy.polynomial nil))
    'emmy.structure (sci/copy-ns emmy.structure (sci/create-ns 'emmy.structure nil))
    'emmy.tape (sci/copy-ns emmy.tape (sci/create-ns 'emmy.tape nil))
    'emmy.util (sci/copy-ns emmy.util (sci/create-ns 'emmy.util nil))
    'emmy.pattern.consequence (sci/copy-ns emmy.pattern.consequence (sci/create-ns 'emmy.pattern.consequence nil))
    'emmy.pattern.syntax (sci/copy-ns emmy.pattern.syntax (sci/create-ns 'emmy.pattern.syntax nil))
    'emmy.pattern.rule (sci/copy-ns emmy.pattern.rule (sci/create-ns 'emmy.pattern.rule nil))
    'emmy.pattern.match (sci/copy-ns emmy.pattern.match (sci/create-ns 'emmy.pattern.match nil))
    'emmy.dual (sci/copy-ns emmy.dual (sci/create-ns 'emmy.dual nil))
    'emmy.numsymb (sci/copy-ns emmy.numsymb (sci/create-ns 'emmy.numsymb nil))
    'emmy.series (sci/copy-ns emmy.series (sci/create-ns 'emmy.series nil))
    'emmy.mechanics.rigid (sci/copy-ns emmy.mechanics.rigid (sci/create-ns 'emmy.mechanics.rigid nil))
    'emmy.mechanics.rotation (sci/copy-ns emmy.mechanics.rotation (sci/create-ns 'emmy.mechanics.rotation nil))
    'emmy.mechanics.noether (sci/copy-ns emmy.mechanics.noether (sci/create-ns 'emmy.mechanics.noether nil))
    'emmy.mechanics.routhian (sci/copy-ns emmy.mechanics.routhian (sci/create-ns 'emmy.mechanics.routhian nil))
    'emmy.mechanics.lagrange (sci/copy-ns emmy.mechanics.lagrange (sci/create-ns 'emmy.mechanics.lagrange nil))
    'emmy.mechanics.hamilton (sci/copy-ns emmy.mechanics.hamilton (sci/create-ns 'emmy.mechanics.hamilton nil))
    'emmy.mechanics.time-evolution (sci/copy-ns emmy.mechanics.time-evolution (sci/create-ns 'emmy.mechanics.time-evolution nil))
    'emmy.numerical.quadrature.boole (sci/copy-ns emmy.numerical.quadrature.boole (sci/create-ns 'emmy.numerical.quadrature.boole nil))
    'emmy.numerical.quadrature.milne (sci/copy-ns emmy.numerical.quadrature.milne (sci/create-ns 'emmy.numerical.quadrature.milne nil))
    'emmy.numerical.quadrature.adaptive (sci/copy-ns emmy.numerical.quadrature.adaptive (sci/create-ns 'emmy.numerical.quadrature.adaptive nil))
    'emmy.numerical.quadrature.simpson38 (sci/copy-ns emmy.numerical.quadrature.simpson38 (sci/create-ns 'emmy.numerical.quadrature.simpson38 nil))
    'emmy.numerical.quadrature.simpson (sci/copy-ns emmy.numerical.quadrature.simpson (sci/create-ns 'emmy.numerical.quadrature.simpson nil))
    'emmy.numerical.quadrature.infinite (sci/copy-ns emmy.numerical.quadrature.infinite (sci/create-ns 'emmy.numerical.quadrature.infinite nil))
    'emmy.numerical.quadrature.common (sci/copy-ns emmy.numerical.quadrature.common (sci/create-ns 'emmy.numerical.quadrature.common nil))
    'emmy.numerical.quadrature.romberg (sci/copy-ns emmy.numerical.quadrature.romberg (sci/create-ns 'emmy.numerical.quadrature.romberg nil))
    'emmy.numerical.quadrature.riemann (sci/copy-ns emmy.numerical.quadrature.riemann (sci/create-ns 'emmy.numerical.quadrature.riemann nil))
    'emmy.numerical.quadrature.trapezoid (sci/copy-ns emmy.numerical.quadrature.trapezoid (sci/create-ns 'emmy.numerical.quadrature.trapezoid nil))
    'emmy.numerical.quadrature.bulirsch-stoer (sci/copy-ns emmy.numerical.quadrature.bulirsch-stoer (sci/create-ns 'emmy.numerical.quadrature.bulirsch-stoer nil))
    'emmy.numerical.quadrature.substitute (sci/copy-ns emmy.numerical.quadrature.substitute (sci/create-ns 'emmy.numerical.quadrature.substitute nil))
    'emmy.numerical.quadrature.midpoint (sci/copy-ns emmy.numerical.quadrature.midpoint (sci/create-ns 'emmy.numerical.quadrature.midpoint nil))
    'emmy.numerical.unimin.bracket (sci/copy-ns emmy.numerical.unimin.bracket (sci/create-ns 'emmy.numerical.unimin.bracket nil))
    'emmy.numerical.unimin.brent (sci/copy-ns emmy.numerical.unimin.brent (sci/create-ns 'emmy.numerical.unimin.brent nil))
    'emmy.numerical.unimin.golden (sci/copy-ns emmy.numerical.unimin.golden (sci/create-ns 'emmy.numerical.unimin.golden nil))
    'emmy.numerical.ode (sci/copy-ns emmy.numerical.ode (sci/create-ns 'emmy.numerical.ode nil))
    'emmy.numerical.quadrature (sci/copy-ns emmy.numerical.quadrature (sci/create-ns 'emmy.numerical.quadrature nil))
    'emmy.numerical.derivative (sci/copy-ns emmy.numerical.derivative (sci/create-ns 'emmy.numerical.derivative nil))
    'emmy.numerical.multimin.nelder-mead (sci/copy-ns emmy.numerical.multimin.nelder-mead (sci/create-ns 'emmy.numerical.multimin.nelder-mead nil))
    'emmy.numerical.minimize (sci/copy-ns emmy.numerical.minimize (sci/create-ns 'emmy.numerical.minimize nil))
    'emmy.numerical.roots.bisect (sci/copy-ns emmy.numerical.roots.bisect (sci/create-ns 'emmy.numerical.roots.bisect nil))
    'emmy.bigfraction (sci/copy-ns emmy.bigfraction (sci/create-ns 'emmy.bigfraction nil))
    'emmy.calculus.basis (sci/copy-ns emmy.calculus.basis (sci/create-ns 'emmy.calculus.basis nil))
    'emmy.calculus.frame (sci/copy-ns emmy.calculus.frame (sci/create-ns 'emmy.calculus.frame nil))
    'emmy.calculus.manifold (sci/copy-ns emmy.calculus.manifold (sci/create-ns 'emmy.calculus.manifold nil))
    'emmy.calculus.hodge-star (sci/copy-ns emmy.calculus.hodge-star (sci/create-ns 'emmy.calculus.hodge-star nil))
    'emmy.calculus.metric (sci/copy-ns emmy.calculus.metric (sci/create-ns 'emmy.calculus.metric nil))
    'emmy.calculus.covariant (sci/copy-ns emmy.calculus.covariant (sci/create-ns 'emmy.calculus.covariant nil))
    'emmy.calculus.form-field (sci/copy-ns emmy.calculus.form-field (sci/create-ns 'emmy.calculus.form-field nil))
    'emmy.calculus.vector-calculus (sci/copy-ns emmy.calculus.vector-calculus (sci/create-ns 'emmy.calculus.vector-calculus nil))
    'emmy.calculus.connection (sci/copy-ns emmy.calculus.connection (sci/create-ns 'emmy.calculus.connection nil))
    'emmy.calculus.derivative (sci/copy-ns emmy.calculus.derivative (sci/create-ns 'emmy.calculus.derivative nil))
    'emmy.calculus.curvature (sci/copy-ns emmy.calculus.curvature (sci/create-ns 'emmy.calculus.curvature nil))
    'emmy.calculus.vector-field (sci/copy-ns emmy.calculus.vector-field (sci/create-ns 'emmy.calculus.vector-field nil))
    'emmy.calculus.coordinate (sci/copy-ns emmy.calculus.coordinate (sci/create-ns 'emmy.calculus.coordinate nil))
    'emmy.calculus.map (sci/copy-ns emmy.calculus.map (sci/create-ns 'emmy.calculus.map nil))
    'emmy.calculus.indexed (sci/copy-ns emmy.calculus.indexed (sci/create-ns 'emmy.calculus.indexed nil))
    'emmy.env (sci/copy-ns emmy.env (sci/create-ns 'emmy.env nil))
    'emmy.simplify.rules (sci/copy-ns emmy.simplify.rules (sci/create-ns 'emmy.simplify.rules nil))
    'emmy.sr.boost (sci/copy-ns emmy.sr.boost (sci/create-ns 'emmy.sr.boost nil))
    'emmy.sr.frames (sci/copy-ns emmy.sr.frames (sci/create-ns 'emmy.sr.frames nil))
    'emmy.algebra.fold (sci/copy-ns emmy.algebra.fold (sci/create-ns 'emmy.algebra.fold nil))
    'emmy.complex.impl (sci/copy-ns emmy.complex.impl (sci/create-ns 'emmy.complex.impl nil))}}
   ))
